import { useEffect, useState } from "react";
import { IUser } from "@/commons/commons.interfaces";

/**
 * Custom hook to get and manage user data from localStorage
 * @returns The parsed user object or null if not found/invalid
 */
const useLocalUser = (): IUser | null => {
  const [user, setUser] = useState<IUser | null>(null);

  useEffect(() => {
    try {
      const userData = localStorage.getItem("user");
      if (userData) {
        const parsedUser = JSON.parse(userData);
        setUser(parsedUser);
      }
    } catch (error) {
      console.error("Failed to parse user data from localStorage:", error);
      // Optionally clear invalid user data
      localStorage.removeItem("user");
      setUser(null);
    }
  }, []);

  return user;
};

export default useLocalUser;
